import styled from 'styled-components';
import Row from 'antd/es/row';

import { Container } from '@shared';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border-left: 1px solid ${({ theme }) => theme.palette.grey300};
  padding-left: 40px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 100%;
    margin-top: 0px;
    padding: 0;
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TourCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 625px;
    width: 100%;
  }

  @media only screen and (max-width: 690px) {
    width: 100%;
    height: auto;
  }
`;

export const ListingCampaignBanner = styled.div`
  margin-bottom: 20px;
  max-width: 880px;
  height: 285px;
  margin-top: 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 1003px;
    width: 100%;
    margin: 0 auto 40px auto;
    & > div {
      padding: 0 !important;
    }
    height: 401px;
  }
`;

export const SEOWrapper = styled.div`
  grid-row: 2/3;
  grid-column: 1/3;
  max-width: 1200px;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 100%;
    padding: 0 15px;
  }
`;

export const ItemsRow = styled(Row)`
  &&& {
    width: 100%;
    margin: 0 auto 0 auto;

    display: grid;
    grid-template-columns: 260px 880px;
    justify-content: center;
    padding: 0 100px;
    gap: 0 20px;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      display: flex;
      padding: 0;
    }
  }
`;

export const SkeletonContainer = styled.div`
  width: 880px;
  display: grid;
  margin-top: 1.4rem;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
    justify-items: center;
  }
`;

export const SearchBarWrapper = styled.div`
  border-bottom: 1px ${({ theme }) => theme.palette.grey300} solid;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 24px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-bottom: 0;
    border-bottom: 0;
  }
`;

export const SearchBarContentWrapper = styled(Container).attrs({
  noPadding: true,
})``;
